import get from 'lodash/get';

import { stepToFieldsMap } from './AddPersonWizard.constants';
import { FormValues, InvitationStep } from './AddPersonWizard.types';

export const extractValuesByStep = <Step extends InvitationStep>(person: FormValues['person'], step: Step) => {
    const fields = stepToFieldsMap[step];

    // `fields` is readonly
    return [...fields].reduce(
        (acc, field) => {
            acc[field] = get(person, field);

            return acc;
        },
        {} as Pick<FormValues['person'], (typeof fields)[number]> & Partial<FormValues['person']>
    );
};
